module.exports = __webpack_public_path__ + "static/media/ArialCEBold.79498192.ttf";